import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';
import { resultAttributes, sorting } from './config';

// Subcomponents.
import Results from './Results';

// We set the hits per page to a large amount which will probably
// never be exceeded, so we can query all items at once.
const SEARCH_THEMES_HITS_PER_PAGE = 100;

interface Subcomponents {
  Results: typeof Results;
}

export interface SearchThemesProps extends Omit<SearchkitWrapperProps,
| 'connection'
| 'indexName'
| 'routing'
| 'analytics'
| 'searchSettings'
| 'hitsPerPage'
> {
  parentId?: number;
}

const SearchThemes: React.FC<SearchThemesProps> & Subcomponents = (props) => {
  const {
    parentId,
    className,
    children,
    ...restProps
  } = props;

  const classes = c('SearchThemes', className);

  return (
    <SearchkitWrapper
      {...restProps}
      className={classes}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexAllThemes}
      hitsPerPage={SEARCH_THEMES_HITS_PER_PAGE}
      searchSettings={{
        search_attributes: [],
        result_attributes: resultAttributes,
        sorting,
      }}
      requestOptions={{
        getBaseFilters: () => [
          {
            bool: {
              must: [
                ...(parentId ? [{
                  term: {
                    taxonomy_parent_tid: {
                      value: parentId,
                    },
                  },
                }] : []),
              ],
            },
          },
        ],
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchThemes.Results = Results;

export default SearchThemes;
